import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import type { ApiResponse, SiteSettings } from '@/types';

// Get site settings (public)
export function useSiteSettings() {
  return useQuery({
    queryKey: ['siteSettings'],
    queryFn: async (): Promise<SiteSettings> => {
      const response = await api.get<ApiResponse<SiteSettings>>('/settings');
      if (!response.data.success || !response.data.data) {
        throw new Error(response.data.error?.message || 'Failed to fetch settings');
      }
      return response.data.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
